import { changePassword, resetPassword } from 'src/app/model/user.model';
import { completeSignUp } from './../../model/user.model';
import { AppService } from './../../app.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageUtil, Constants } from 'src/app/helpers/messages';
import { MustMatch } from 'src/app/helpers/match-helper';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {

  
  loginForm:FormGroup
  errorMsg: string;
  currentDate = new Date().getFullYear()
  payload = new completeSignUp

  loading: boolean = false;
  hide: boolean = true;
  email: string;
  token: string;
  category: string;

  
  constructor(private fb:FormBuilder, private route: ActivatedRoute, private router:Router, private app: AppService) {
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.category = params['category'];
      this.token = params['token']
  });
   }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      'password':['', Validators.required],
      'confirmpassword':['', Validators.required],
    }, {
      validator: MustMatch('password', 'confirmpassword')
    })
  }

  signIn() {
    
    if (this.loginForm.value.password !== this.loginForm.value.confirmpassword) {
      this.errorMsg = 'Password and confirm password must be equal.'
    }else{
      this.loading = true;
      this.payload.category = this.category
      this.payload.email = this.email.toLowerCase()
      this.payload.token = this.token 
      this.payload.password = this.loginForm.value.password;
      if(this.category === "Activation"){
      this.app.userService.activateSignUp(this.payload)
      .subscribe(res => {
        if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
          this.loading = false
          
          // this.app.helperService.saveToStore(Constants.LOGIN_USER,res['data'])
    this.router.navigateByUrl('login')

          // this.login()
          // this.app.setLoginStatus()
          this.app.snackBar.open("Sign up completed, you can now login.", 'Dismiss', {
            duration:MessageUtil.TIMEOUT_DURATION
          }) 
        }
        else { 
          this.loading = false
          this.app.snackBar.open(res['data'], 'Dismiss', {
            duration:MessageUtil.TIMEOUT_DURATION
          }) 
        }
      }, err => {
        this.loading = false
        this.app.snackBar.open(MessageUtil.SAVE_NOT_DONE, 'Dismiss', {
          duration:MessageUtil.TIMEOUT_DURATION
        })       
      })
    }else{
      let tempPayload = new resetPassword
      tempPayload.email = this.email.toLowerCase()
      tempPayload.newpassword = this.loginForm.value.password;
      tempPayload.tokens = this.token
      this.app.userService.resetPasswordComplete(tempPayload)
      .subscribe(res => {
        if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
          this.loading = false
          
          // this.app.helperService.saveToStore(Constants.LOGIN_USER,res['data'])
          this.router.navigateByUrl('login')

          // this.login()
          // this.app.setLoginStatus()
          this.app.snackBar.open(res['data'], 'Dismiss', {
            duration:MessageUtil.TIMEOUT_DURATION
          }) 
        }
        else { 
          this.loading = false
          this.app.snackBar.open(res['data'], 'Dismiss', {
            duration:MessageUtil.TIMEOUT_DURATION
          }) 
        }
      }, err => {
        this.loading = false
        this.app.snackBar.open(MessageUtil.SAVE_NOT_DONE, 'Dismiss', {
          duration:MessageUtil.TIMEOUT_DURATION
        })       
      })
    }
    }
  }


}
